import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "components/bootstrap";
const GreyNoiseAdapterFieldSet = ({
  config,
  setFieldValue,
  validationMessage,
  validationState
}) => {
  var _a, _b;
  const { t } = useTranslation("integrations");
  const [isCreate] = useState(() => {
    var _a2;
    return !((_a2 = config.api_token) == null ? void 0 : _a2.keep_value);
  });
  const [showResetPasswordButton, setShowResetPasswordButton] = useState(!!((_a = config.api_token) == null ? void 0 : _a.keep_value));
  const setUserPassword = (nextUserPassword) => {
    setFieldValue("config.api_token", nextUserPassword);
  };
  const handleUserPasswordChange = ({ target }) => {
    const typedPassword = target.value;
    let nextPassword = { set_value: typedPassword };
    if (typedPassword === "") {
      nextPassword = { delete_value: true };
    }
    setUserPassword(nextPassword);
  };
  const toggleUserPasswordReset = () => {
    if (showResetPasswordButton) {
      setUserPassword({ delete_value: true });
      setShowResetPasswordButton(false);
      return;
    }
    setUserPassword({ keep_value: true });
    setShowResetPasswordButton(true);
  };
  return /* @__PURE__ */ React.createElement("fieldset", null, showResetPasswordButton ? /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "api_token",
      label: t("grey_noise_adapter_field_set.user_password_label"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(Button, { onClick: toggleUserPasswordReset }, t("grey_noise_adapter_field_set.reset_token_button"))
  ) : /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "password",
      id: "api_token",
      name: "api_token",
      label: t("grey_noise_adapter_field_set.api_token_label"),
      buttonAfter: !isCreate ? /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: toggleUserPasswordReset }, t("grey_noise_adapter_field_set.undo_reset_button")) : void 0,
      onChange: handleUserPasswordChange,
      help: validationMessage("api_token", t("grey_noise_adapter_field_set.api_token_help")),
      bsStyle: validationState("api_token"),
      value: ((_b = config.api_token) == null ? void 0 : _b.set_value) || "",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      required: true
    }
  ));
};
export default GreyNoiseAdapterFieldSet;
